import { render } from "./DashboardCard.vue?vue&type=template&id=02cf4b0a&scoped=true"
import script from "./DashboardCard.vue?vue&type=script&lang=ts"
export * from "./DashboardCard.vue?vue&type=script&lang=ts"

import "./DashboardCard.vue?vue&type=style&index=0&id=02cf4b0a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-02cf4b0a"

export default script